<template>
  <AppAlerts/>
  <router-view></router-view>
</template>


<script>
import AppAlerts from "@/components/layout/TheAlerts";

export default {
  components: {AppAlerts},
  created() {
    let htmlEl = document.querySelector("html");
    htmlEl.setAttribute('dir', 'rtl');
    htmlEl.setAttribute('lang', 'fa');
  }
}
</script>